/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import FadeIn from 'react-fade-in';
import Preloader from 'src/components/Preloader';
import useStyles from '../styles';

const StepThree = ({
  data,
  handleNext,
  handleBack,
  handleSubmit,
  loading,
  handleClose
}) => {
  const { classes } = useStyles();

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation();

  const handleAction = async () => {
    if (data.balance === 0) {
      try {
        setIsSubmitting(true);
        await handleSubmit();
        setIsSubmitted(true);
      } catch (error) {
        console.error('Error submitting:', error);
      } finally {
        setIsSubmitting(false);
      }
    } else {
      handleNext();
    }
  };

  if (loading) {
    return <Preloader />;
  }

  if (isSubmitted) {
    return (
      <FadeIn>
        <Box className={classes.container}>
          <Box style={{ padding: '10px', margin: '2rem 1rem' }}>
            <Typography style={{ fontSize: '20px' }}>
              {t('COMMON.CEDE_CONTRACT_EFFECT')}
            </Typography>
          </Box>
          <Box className={classes.box} display="flex" justifyContent="center">
            <Button
              className={clsx(classes.buttons, classes.buttonMain)}
              onClick={() => {
                handleClose();
                window.location.reload();
              }}
              color="primary"
              variant="contained"
            >
              {t('COMMON.ACCEPT')}
            </Button>
          </Box>
        </Box>
      </FadeIn>
    );
  }

  return (
    <FadeIn>
      <form onSubmit={handleAction}>
        <Box className={classes.container}>
          <Box style={{ padding: '10px', margin: '2rem 1rem' }}>
            <Typography style={{ fontSize: '20px' }}>
              {`${t('COMMON.CEDE_CONTRACT_CLICK_ACCEPT')} `}
              <strong>{t('COMMON.ACCEPT')}</strong>
              {` ${t('COMMON.CEDE_CONTRACT_WILL_BE_CEDED')} `}
              <Typography
                component="span"
                style={{ fontWeight: 'bold', fontSize: '20px' }}
              >
                {data.contractId}
              </Typography>
              {` ${t('COMMON.CEDE_CONTRACT_CORRESPONDING_TO')} `}
              <Typography
                component="span"
                style={{ fontWeight: 'bold', fontSize: '20px' }}
              >
                {data.equipmentId}
              </Typography>
              {` ${t('COMMON.CEDE_CONTRACT_BRAND')} `}
              <Typography
                component="span"
                style={{ fontWeight: 'bold', fontSize: '20px' }}
              >
                {data.equipmentBrand}
              </Typography>
              {` ${t('COMMON.CEDE_CONTRACT_MODEL')} `}
              <Typography
                component="span"
                style={{ fontWeight: 'bold', fontSize: '20px' }}
              >
                {data.equipmentModel}
              </Typography>
              {`, ${t('COMMON.CEDE_CONTRACT_FROM')} `}
              <Typography
                component="span"
                style={{ fontWeight: 'bold', fontSize: '20px' }}
              >
                {data.clientName}
              </Typography>
              {` ${t('COMMON.CEDE_CONTRACT_TO')} `}
              <Typography
                component="span"
                style={{ fontWeight: 'bold', fontSize: '20px' }}
              >
                {data.cededClientName}
              </Typography>
              {`. ${t('COMMON.CEDE_CONTRACT_WILL_TAKE_EFFECT')} `}
              <Typography
                component="span"
                style={{ fontWeight: 'bold', fontSize: '20px' }}
              >
                {data.cedeDate?.format('MMMM')}
              </Typography>
              {` ${t('COMMON.CEDE_CONTRACT_OF')} `}
              <Typography
                component="span"
                style={{ fontWeight: 'bold', fontSize: '20px' }}
              >
                {data.cedeDate?.format('YYYY')}
              </Typography>
              .
            </Typography>
          </Box>
          <Box
            className={classes.box}
            display="flex"
            justifyContent="space-between"
          >
            <Button
              className={classes.buttons}
              onClick={handleBack}
              color="primary"
              variant="outlined"
              disabled={isSubmitting}
            >
              {t('COMMON.BACK')}
            </Button>
            <LoadingButton
              className={clsx(classes.buttons, classes.buttonMain)}
              onClick={handleAction}
              color="primary"
              variant="outlined"
              loading={loading || isSubmitting}
              disabled={isSubmitting}
            >
              {data.balance === 0 ? t('COMMON.ACCEPT') : t('COMMON.NEXT')}
            </LoadingButton>
          </Box>
        </Box>
      </form>
    </FadeIn>
  );
};

StepThree.propTypes = {
  data: PropTypes.object,
  handleNext: PropTypes.func,
  handleBack: PropTypes.func,
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool,
  handleClose: PropTypes.func
};

export default StepThree;
